import { TenantBillingStatus } from "aevocam-rest-api-spec";

export const tenantBillingStatusNames = {
  [TenantBillingStatus.Unbillable]: 'Not yet enrolled',
  [TenantBillingStatus.AutoPay]: 'Automatic payments',
  [TenantBillingStatus.Free]: 'No payments required',
  [TenantBillingStatus.ManualPay]: 'Manual payments',
} as const
